import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trainersAction } from "src/store/Slices/Administrator/TrainersSlice";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import AddEditTrainerModal from "./Modals/AddEditTrainerModal";
import SureModal from "src/components/Modals/SureModal";
import AdminTable from "../Helpers/AdminTable";
import { useEffect } from "react";
import { Image, message, Tooltip } from "antd";
import fallback from "./fallback.png";
import { copyToClipboard } from "src/components/helpers/copyToClipboard";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";
import CreatePacketsModal from "./Modals/CreatePacketsModal";

const Trainers = ({ mnemo }) => {
  // HELPERS
  const dispatch = useDispatch();
  const searchInput = useRef(null);

  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal({ open: true, flag: "edit" });
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
    },
    {
      key: "2",
      label: "Удалить",
      onClick: () => {
        setIsOpenDeleteModal(true);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
    },
    {
      key: "3",
      label: "Получить ссылку на изображение",
      onClick: () => {
        copyToClipboard(trainerInfo?.imageUrl?.props?.src);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "getImageLink"),
    },
  ];

  const filterOptionsArr = [
    { label: "Фильрация", value: 0, index: undefined },
    { label: "По номеру", value: 1, index: "id", title: "Тренер" },
    { label: "По имени", value: 2, index: "name", title: "Имя" },
    { label: "По типу", value: 3, index: "typeName", title: "Тип" },
    {
      label: "По изображению",
      value: 4,
      index: "imageUrl",
      title: "Изображения",
    },
    {
      label: "По образованию",
      value: 5,
      index: "education",
      title: "Образование",
    },
    { label: "По стажу", value: 6, index: "experience", title: "Стаж" },
    { label: "По клубу", value: 7, index: "clubName", title: "Клуб" },
    {
      label: "По категории",
      value: 8,
      index: "isTop",
      title: "Высшая категория",
    },
  ];

  // STATE
  const [isDeleted, setIsDeleted] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [trainerInfo, setTrainerInfo] = useState();
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
    open: false,
    flag: "",
  });
  const [isOpenModalCreate, setIsOpenModalCreate] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  // STORE
  const trainersList = useSelector((state) => state.TrainersSlice.trainersList);
  const trainersListLoading = useSelector(
    (state) => state.TrainersSlice.trainersListLoading
  );

  const onClickDelete = () => {
    dispatch(
      trainersAction({ flag: "delete", value: { id: trainerInfo.id } })
    ).then(() => {
      dispatch(trainersAction({ flag: "get" }));
      setIsOpenDeleteModal(false);
    });
    setPage(1);
    setPageSize(20);
  };

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0];
            formattedItems["idTo"] = values[index][1];
          } else if (key === "typeName") {
            formattedItems["typeId"] = values[index][0];
          } else if (key === "clubName") {
            formattedItems["clubId"] = values[index][0];
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const clickOnAction = (element) => {
    setTrainerInfo(element);
  };

  const handlePaginationChange = (page, pageSize) => {
    dispatch(
      trainersAction({
        flag: "get",
        value: {
          count: pageSize,
          offset: pageSize * (page - 1),
        },
      })
    );
    setPage(page);
    setPageSize(pageSize);
  };

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1);
    setPageSize(20);
    dispatch(
      trainersAction({
        flag: "get",
        value: {
          isDeleted: isDeleted,
          [`${dataIndex}`]: selectedKeys[0],
        },
      })
    );
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      trainersAction({
        flag: "get",
        value: {
          isDeleted: isDeleted,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  useEffect(() => {
    dispatch(trainersAction({ flag: "get" }));
  }, []);

  const showDeletedItems = (value) => {
    setIsDeleted(value);
    dispatch(trainersAction({ flag: "get", value: { isDeleted: value } }));
    setPage(1);
    setPageSize(20);
  };

  const formatedRows = trainersList?.data?.value?.rows.map((element) => {
    return {
      ...element,
      imageUrl: (
        <Image
          alt="Отсутствует изображение"
          width={120}
          src={element?.imageUrl}
          fallback={fallback || "https://placehold.co/400x400?text=No+Photo"}
        />
      ),
      education: element?.education ? (
        <Tooltip title={element?.education}>
          {element?.education.slice(0, 100) +
            (element?.education.length > 100 ? "..." : "")}
        </Tooltip>
      ) : (
        "-"
      ),
      experience: element?.experience ? (
        <Tooltip title={element?.experience}>
          {element?.experience.slice(0, 50) +
            (element?.experience.length > 200 ? "..." : "")}
        </Tooltip>
      ) : (
        "-"
      ),
    };
  });

  return (
    <>
      <AddEditTrainerModal
        visible={isOpenAddEditModal}
        setVisible={setIsOpenAddEditModal}
        trainerInfo={trainerInfo}
        setPage={setPage}
        setPageSize={setPageSize}
      />
      <CreatePacketsModal
        visible={isOpenModalCreate}
        setVisible={setIsOpenModalCreate}
        setPage={setPage}
        setPageSize={setPageSize}
      />
      <SureModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickYes={onClickDelete}
      />
      {console.log(mnemo)}
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={trainersListLoading}
          onClickRowOne={(record) => {
            setTrainerInfo(record);
          }}
          columns={trainersList}
          // rows={trainersList?.data?.value?.rows}
          rows={formatedRows}
          total={trainersList?.data?.value?.totalCount}
          title={() => (
            <TableTitle
              isDeleted={isDeleted}
              showDeletedItems={showDeletedItems}
              onClickOpenModal={() => {
                setIsOpenAddEditModal({
                  open: true,
                  flag: "add",
                });
              }}
              onClickOpenModalCreate={() => {
                setIsOpenModalCreate(true);
              }}
              mnemoButton={
                !mnemo?.children?.find((el) => el.mnemo === "insertBtn")
              }
              mnemoButtonCreate={{
                show: true,
                mnemo: !mnemo?.children?.find(
                  (el) => el.mnemo === "packetsCreateBtn"
                ),
              }}
              mnemoSwitcher={
                !mnemo?.children?.find((el) => el.mnemo === "isDeletedBtn")
              }
            />
          )}
          items={items}
          isDeleted={isDeleted}
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          elementsList={trainersList}
          elementsListLoading={trainersListLoading}
          setIsOpenAddEditModal={setIsOpenAddEditModal}
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          items={items}
          onChange={handleTableChange}
          filterOptionsArr={filterOptionsArr}
          clickOnAction={clickOnAction}
          handlePaginationChange={handlePaginationChange}
          searchInput={searchInput}
          onClickSearchItem={onClickSearchItem}
        />
      )}
    </>
  );
};

export default Trainers;
